/*
 * Crème mains offerte avec un code promo (ex. NOELCADEAU, LYPSSITECADEAU).
 *
 * Quand le client saisit ce code dans le champ "Code promo" du panier (panier flottant ou page panier),
 * on n'applique pas le code tout de suite : on affiche d'abord une fenêtre pour choisir la crème (parmi
 * celles du réglage du thème). La crème choisie est ajoutée au panier, puis le code est appliqué; la remise
 * "offert" elle-même est calculée par Shopify (code "achetez X, obtenez Y").
 *   - panier vide, ou sans autre produit que les crèmes : message, rien n'est ajouté (la crème ne serait pas offerte)
 *   - une crème est déjà dans le panier : on applique seulement le code, sans en ajouter une deuxième
 *   - si Shopify indique que le code n'est pas applicable après l'ajout, la crème ajoutée est retirée
 * La crème ajoutée porte la propriété cachée _code_cadeau (visible dans les commandes).
 *
 * Plusieurs codes sont possibles (réglage séparé par des virgules). L'API window.cdpGiftCode permet à d'autres
 * scripts (ex. la chasse aux citrouilles) d'ouvrir la même fenêtre sans passer par le champ "Code promo".
 * Événement émis quand une crème est ajoutée et le code appliqué : cdp:gift-code:applied (detail.code).
 */
(function () {
  if (window.__giftCodeBound) return;
  window.__giftCodeBound = true;

  var cfgEl = document.getElementById('gift-code-config');
  var picker = document.getElementById('gift-code-picker');
  if (!cfgEl || !picker) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var root = cfg.root || '/';
  var giftIds = cfg.products.map(function (p) { return p.variantId; });
  var codes = (cfg.codes || []).map(function (c) { return String(c).trim().toUpperCase(); }).filter(Boolean);
  var activeCode = codes[0] || '';
  var busy = false;
  var activeInput = null;
  var messageEl = picker.querySelector('.gift-code-picker__message');

  function norm(s) { return (s || '').trim().toUpperCase(); }
  function isGift(value) { return codes.indexOf(norm(value)) !== -1; }
  function isDiscountInput(el) { return !!el && el.tagName === 'INPUT' && /discount-field/i.test(el.id || ''); }

  function sectionIds() {
    try { return Alpine.store('xCartHelper').getSectionsToRender().map(function (s) { return s.id; }); } catch (e) { return []; }
  }
  async function render(sections) {
    try {
      if (sections) await Alpine.store('xCartHelper').reRenderSections(sections);
      Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML, 10) || 0;
    } catch (e) { /* le panier se mettra à jour à la prochaine action */ }
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }
  async function post(path, body) {
    var response = await fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    return response.json();
  }
  function appliedCodes() {
    try {
      var store = Alpine.store('xCouponCodeDetail');
      store.getDiscountCode();
      return JSON.parse(JSON.stringify(store.appliedDiscountCodes || []));
    } catch (e) { return []; }
  }

  function showMessage(text) {
    messageEl.textContent = text;
    messageEl.hidden = !text;
  }
  function setCardsDisabled(state) {
    picker.querySelectorAll('.gift-code-picker__card').forEach(function (b) { b.disabled = state; });
  }
  function openPicker() {
    var label = picker.querySelector('[data-gift-code-label]');
    if (label) label.textContent = activeCode;
    showMessage('');
    setCardsDisabled(false);
    picker.hidden = false;
    var first = picker.querySelector('.gift-code-picker__card');
    if (first) first.focus();
  }
  function closePicker() {
    picker.hidden = true;
    showMessage('');
  }
  function clearInput() {
    if (activeInput) {
      activeInput.value = '';
      activeInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  // Applique le code et met à jour le panier; renvoie la réponse de Shopify
  async function applyCode() {
    var applied = appliedCodes();
    if (applied.indexOf(activeCode) === -1) applied.push(activeCode);
    var data = await post('cart/update.js', { discount: applied.join(','), sections: sectionIds() });
    var entry = (data.discount_codes || []).filter(function (c) { return c.code.toUpperCase() === activeCode; })[0];
    var applicable = !!(entry && entry.applicable);
    try {
      var store = Alpine.store('xCouponCodeDetail');
      store.appliedDiscountCodes = (data.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
      document.cookie = 'eurus_discount_code=' + store.appliedDiscountCodes + '; path=/';
    } catch (e) { /* champ code promo non actif */ }
    await render(data.sections);
    document.dispatchEvent(new CustomEvent('eurus:cart:discount-code:change'));
    return { data: data, applicable: applicable };
  }

  // Point d'entrée : le client a saisi le code
  async function start(input, code, opts) {
    if (busy) return 'busy';
    busy = true;
    activeInput = input || null;
    if (code) activeCode = norm(code);
    opts = opts || {};
    try {
      var cart = await (await fetch(root + 'cart.js')).json();
      var items = cart.items || [];
      var hasGift = items.some(function (i) { return giftIds.indexOf(i.variant_id) !== -1; });
      var others = items.filter(function (i) { return giftIds.indexOf(i.variant_id) === -1; }).length;

      if (!items.length || (!hasGift && !others)) {
        if (opts.silentNeedsProduct) return 'needs-product';
        openPickerMessageOnly();
        return 'needs-product';
      }
      if (hasGift) {
        // une crème est déjà dans le panier : on applique seulement le code
        var res = await applyCode();
        if (res.applicable) {
          clearInput();
          notifyApplied();
          return 'applied';
        }
        openPickerMessageOnly(cfg.messages.needProduct);
        return 'needs-product';
      }
      openPicker();
      return 'picker';
    } catch (e) {
      console.error('[gift-code]', e);
      return 'error';
    } finally {
      busy = false;
    }
  }
  function notifyApplied() {
    document.dispatchEvent(new CustomEvent('cdp:gift-code:applied', { detail: { code: activeCode } }));
  }
  function openPickerMessageOnly(text) {
    picker.hidden = false;
    setCardsDisabled(true);
    showMessage(text || cfg.messages.needProduct);
  }

  async function pick(variantId) {
    if (busy) return;
    busy = true;
    setCardsDisabled(true);
    showMessage('');
    try {
      var add = await post('cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _code_cadeau: activeCode } }] });
      if (add.status) throw new Error(add.description || add.message || 'add failed');
      var res = await applyCode();
      if (res.applicable) {
        closePicker();
        clearInput();
        notifyApplied();
        return;
      }
      // code non applicable malgré l'ajout : on retire la crème pour ne pas la facturer
      var line = (res.data.items || []).filter(function (i) { return i.variant_id === variantId && i.properties && i.properties._code_cadeau; })[0];
      if (line) {
        var updates = {};
        updates[line.key] = 0;
        var undone = await post('cart/update.js', { updates: updates, sections: sectionIds() });
        await render(undone.sections);
      }
      setCardsDisabled(false);
      showMessage(cfg.messages.error);
    } catch (e) {
      console.error('[gift-code]', e);
      setCardsDisabled(false);
      showMessage(cfg.messages.error);
    } finally {
      busy = false;
    }
  }

  // Interception (phase de capture) avant le traitement standard du champ "Code promo" du thème
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !isDiscountInput(event.target) || !isGift(event.target.value)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Enter' || !isDiscountInput(event.target) || !isGift(event.target.value)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    start(event.target, norm(event.target.value));
  }, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button');
    if (button && button.parentElement) {
      var input = button.parentElement.querySelector('input[id*="discount-field"]');
      if (input && isGift(input.value)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        start(input, norm(input.value));
        return;
      }
    }
    if (picker.hidden) return;
    if (event.target.closest('[data-gift-close]')) {
      event.preventDefault();
      closePicker();
      return;
    }
    var card = event.target.closest('.gift-code-picker__card');
    if (card) {
      event.preventDefault();
      pick(parseInt(card.getAttribute('data-gift-variant-id'), 10));
    }
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !picker.hidden) closePicker();
  });

  window.cdpGiftCode = {
    isGiftCode: isGift,
    // Ouvre le choix de la crème pour ce code. Renvoie 'picker', 'applied', 'needs-product', 'busy' ou 'error'.
    open: function (code, opts) { return start(null, code, opts); }
  };
})();
